module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAAGEp02aAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATdJREFUeNpiDE3a8p8BCFiAmBHEYGKAAoAAYoRJgUTKYYwuEAMggEBSDEjgP0zTf5gIWICTkwOEwYIAAQQ3DQZYYNYga9mPrAIk0Adl28MENkMFDiLb8h9mC0AAwRz2H9lgJLcxMjEQAMjO+o8m14ocPp+AmB+qEIarkRXwQhVhteI/eoAhOxQggDDCCpsJjBR5k2wFZbBYYkEKFHTHoiQkUKA4IAUSCPgimwCPTigAheoTIObD5YZP0NBlIDo24ckQBr5//4EaFzAB9NAECDCCcUGMExjRYpuRgJ7/2MKRbIBswGcozYdHPS+U/oLNgGgo/RGWKdGAPVKqj8JmwGZYRgKCA1C/IuMDSOlqMzYD9kHTVAVa5kPG5VA1+5ALM4YBjQUWdAH0JIkO0FMkVVzwH58NhMICAPhzUdysXVsoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/shalou.png
// module id = MojI
// module chunks = 2